import { useMemo, useState, useEffect } from "react";
import {
  X,
  Bell,
  Check,
  CheckCircle2,
  AlertCircle,
  Info,
  CircleX,
} from "lucide-react";
import "./Notifications.css";
import { apiGet,apiPatch } from "../../Services/Services";
import { ENDPOINTS } from "../../Services/Endpoints";
import NotificationModal from "./NotificationModal";

const initialNotifications = [
  {
    id: 1,
    type: "success",
    title: "Payment Processed",
    message:
      "Payment of $125.00 SGD from Sarah Chen has been successfully processed.",
    time: "Apr 20, 02:30 PM",
    read: false,
  },
  {
    id: 2,
    type: "alert",
    title: "Mission Completion Alert",
    message:
      "Urban Mapping Project has reached 95% completion. Review pending submissions.",
    time: "Apr 20, 01:15 PM",
    read: false,
  },
  {
    id: 3,
    type: "info",
    title: "New User Registration",
    message:
      "Marcus Johnson has registered and joined the Coastal Survey mission.",
    time: "Apr 20, 11:45 AM",
    read: false,
  },
  {
    id: 4,
    type: "error",
    title: "Payment Failed",
    message:
      "Payment attempt of $72.30 USD from Robert Taylor has failed. User notified.",
    time: "Apr 20, 10:20 AM",
    read: true,
  },
  {
    id: 5,
    type: "success",
    title: "Team Created",
    message: "New team 'Mountain Explorers' has been created with 5 members.",
    time: "Apr 20, 09:30 AM",
    read: true,
  },
  {
    id: 6,
    type: "info",
    title: "System Maintenance",
    message:
      "Scheduled maintenance will occur on April 25th from 2:00 AM to 4:00 AM SGT.",
    time: "Apr 19, 04:00 PM",
    read: true,
  },
];

const iconByType = {
  success: CheckCircle2,
  alert: AlertCircle,
  info: Info,
  error: CircleX,
};


function Notifications({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      const response = await apiGet(
        ENDPOINTS.notifications.latest,
        {},
        {},
        {
          showSuccessToast: false,
          useApiSuccessMessage: false,
        },
      );

      const notifications = response?.data ?? [];

      setItems(notifications);
    } catch (error) {
      console.error("Notification fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchNotifications();
    }
  }, [open]);

  const unreadCount = useMemo(
    () => items.filter((item) => !item.isRead).length,
    [items],
  );

  // const markAllRead = () => {
  //   setItems((prev) =>
  //     prev.map((item) => ({
  //       ...item,
  //       read: true,
  //     })),
  //   );
  // };
  const markAllRead = async () => {
    try {
      const response = await apiPatch(
        ENDPOINTS.notifications.markAllRead,
        {},
        {},
        {
          showSuccessToast: false,
        },
      );

      setItems((prev) =>
        prev.map((item) => ({
          ...item,
          isRead: true,
        })),
      );

      console.log("MARK ALL READ RESPONSE", response);
    } catch (error) {
      console.error("MARK ALL READ ERROR", error);
    }
  };

  if (!open) return null;

  return (
    <div className="notifications-overlay" onClick={onClose}>
      <aside
        className="notifications-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="notifications-head">
          <div className="notifications-title-row">
            <div className="notifications-title-wrap">
              <Bell size={18} />

              <h2>Notifications</h2>

              {unreadCount > 0 && (
                <span className="notifications-new">{unreadCount} new</span>
              )}
            </div>

            <button className="notifications-close-btn" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <p>Stay updated with platform activities and alerts</p>
        </div>

        <div className="notifications-toolbar">
          <span>Recent Notifications</span>

          <button className="notifications-mark-read" onClick={markAllRead}>
            <Check size={14} />
            Mark All Read
          </button>

          <button
            type="button"
            className="notifications-mark-read"
            onClick={() => setShowAll(true)}
          >
            View All
          </button>
        </div>

        <div className="notifications-list">
          {loading && <p>Loading...</p>}

          {!loading &&
            items.map((item) => {
              const Icon = iconByType[item.type] || Info;

              return (
                <article
                  key={item.id}
                  className={`notification-card ${
                    item.isRead ? "read" : "unread"
                  }`}
                >
                  {/* <div className={`notification-icon ${item.type}`}>
                    <Icon size={16} />
                  </div> */}

                  <div className="notification-content">
                    <div className="notification-card-head">
                      <h3>
                        {item.type}

                        {!item.isRead && <span className="notification-dot" />}
                      </h3>
                    </div>

                    <p>{item.message}</p>

                    <time>{item.time}</time>
                  </div>
                </article>
              );
            })}
        </div>
      </aside>
      <NotificationModal open={showAll} onClose={() => setShowAll(false)} />
    </div>
  );
}
export default Notifications;
